<div pTooltip="Enable Additional Fees" tooltipPosition="top" style="display: inline-block">
  <p-inputSwitch [(ngModel)]="enable" (onChange)="getAdditionalfeesList(enable)"></p-inputSwitch>
</div>

<p-table [value]="allDiscounts" *ngIf="enable">
  <ng-template pTemplate="header">
    <tr>
      <th>Name</th>
      <th>Additional Fees Type</th>
      <th>Value</th>
      <th>Is Active</th>
      <th>Action</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-additionalFee let-i="rowIndex">
    <tr>
      <td>{{additionalFee.name}}</td>
      <td>{{additionalFee.type?additionalFee.type.name:''}}</td>
      <td>
        <span *ngIf="additionalFee.type?.name == discountConstantsProperty.AmountDiscountType">{{baseCurrency?.symbol ?? ''}}{{additionalFee.discountValue | customNumberFormat: fractionDigits}}</span>
        <span *ngIf="additionalFee.type?.name == discountConstantsProperty.PercentageDiscountType">{{additionalFee.discountValue | customNumberFormat: fractionDigits}}{{additionalFee.type?.description}}</span>
      </td>
      <td>{{additionalFee.statusId==statusConstants.ACTIVE?answertypeConstants.Yes:answertypeConstants.No}}</td>
      <td class="action">
        <span class="btnBars p-mr-0" (click)="showEditAdditionalFees(additionalFee)" pTooltip="Edit" tooltipPosition="top"><i
            class="pi pi-pencil"></i></span>
        <span class="btnBars p-mr-0" *ngIf="additionalFee.createdSource!='System'" (click)="checkDeleteStatus(additionalFee)" pTooltip="Delete"
          tooltipPosition="top"><i class="pi pi-trash"></i></span>
      </td>
    </tr>
  </ng-template>
</p-table>


<p-dialog header="{{addEditDiscountHeader}}" [(visible)]="displayAdditionalFeesAdd" [modal]="true" [responsive]="true"
[style]="{width: '60vw'}" (onHide)="additionalFeeForm.reset()">
<form [formGroup]="additionalFeeForm">
    <div class="header">
        <h5>Additional Fees Information
          <p-inputSwitch class="header-switch" formControlName="statusId" [disabled]="isSystem"></p-inputSwitch>
        </h5>
      </div>
      <div class="card">
        <div class="p-field p-formgrid p-grid">
          <div class="p-col-12 p-md-6">
            <label>Name <span style="color: red;">*</span></label>
              <input pInputText type="text" (focus)="isDuplicacy = false" formControlName="name" [readonly]="isSystem"/>
              <small *ngIf="isDuplicacy" class="p-invalid">Name already exists.</small>
          </div>
          <div class="p-col-12 p-md-6">
            <label>Additional Fees Section <span style="color: red;">*</span></label>
            <p-dropdown [options]="discountSectionOptions " formControlName="discountCategoryId" optionLabel="label" optionValue="value"
              placeholder="Select Additional Fees Section" ></p-dropdown>
          </div>
        </div>
        <!-- Discount By -->
        <div class="p-field p-formgrid p-grid">
          <div class="p-col-12 p-md-6">
            <label>Additional Fees Type</label>
            <p-dropdown [options]="discountBy" formControlName="discountBy" optionLabel="name" 
              placeholder="Select Type" appendTo="body" [disabled]="!isAddDiscount"></p-dropdown>
          </div>
          <!-- Amount -->
          <div class="p-col-12 p-md-6" *ngIf="additionalFeeForm.controls['discountBy'].value && additionalFeeForm.controls['discountBy'].value.name==discountConstantsProperty.AmountDiscountType">
            <label>Amount <span style="color: red;">*</span></label>
            <input type="text" pInputText formControlName="discountValue" [readonly]="isSystem" appDecimalNumber [length]="fractionDigits">
          </div>
          <!-- percentage -->
          <div class="p-col-12 p-md-6" *ngIf="additionalFeeForm.controls['discountBy'].value && additionalFeeForm.controls['discountBy'].value.name==discountConstantsProperty.PercentageDiscountType">
            <label>Percentage <span style="color: red;">*</span></label>
            <input type="text" pInputText formControlName="discountValue" [readonly]="isSystem" appDecimalNumber [length]="fractionDigits">
          </div>
        </div>

        <div class="p-field p-formgrid p-grid">
          <div class="p-col-12">
            <label>Finance Account <span style="color: red;">*</span></label>
            <p-treeSelect class="border-bottom-input" [options]="financialAccounts" appendTo="body" 
            placeholder="Select Financial Account" formControlName="incomeAccount" display="comma"
            [metaKeySelection]="false" selectionMode="single"></p-treeSelect>
          </div>
        </div>
        <div class="p-field p-formgrid p-grid">
          <div class="p-col-12" *ngIf="additionalFeeForm.get('discountCategoryId').value !== 2">
            <div class="p-field-checkbox p-mb-0 p-mt-3">
              <p-checkbox formControlName="isTaxable" binary="true" inputId="taxable" 
              [ngModelOptions]="{standalone: true}"></p-checkbox>
              <label class="p-my-0" for="taxable">Taxable</label>
            </div>
            <p class="small p-text-light p-ml-5">
              If checked, sale tax will be calculated on the order total after discount has been applied.
            </p>
          </div>
        </div>
      </div>
</form>

<p-footer >
  <button type="button" pButton (click)="onCancel()" label="Cancel" class="p-button-secondary"></button>
  <button type="button" pButton  [disabled]="!additionalFeeForm.valid"
  (click)="saveAdditionalFee(additionalFeeForm.value)" label="Save"></button>
</p-footer>
</p-dialog>